import { render, staticRenderFns } from "./OnboardingPhotos.vue?vue&type=template&id=c963d2cc&"
import script from "./OnboardingPhotos.vue?vue&type=script&lang=js&"
export * from "./OnboardingPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports